/**
 * @file: factory.ts
 * @author: eric <eric.blueplus@gmail.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import {
  InspectionTaskEventSubType,
  InspectionTaskEventType,
} from '@euler/model/enum';
import { TimelineItemInfoBuilderImpl } from './builders/item-builder';
import { getTimelineItemBuilder } from './registry';
import { EventInfo, TimelineItemInfo, TimelineSectionType } from './types';

const EventType2SectionTypeMap = new Map<
  InspectionTaskEventType,
  TimelineSectionType
>([
  [InspectionTaskEventType.Creation, 'order'],
  [InspectionTaskEventType.PreInspection, 'pre-inspection'],
  [InspectionTaskEventType.Inspection, 'inspection'],
  [InspectionTaskEventType.Quotation, 'quotation'],
  [InspectionTaskEventType.Construction, 'construction'],
  [InspectionTaskEventType.DeliveryCheck, 'delivery-check'],
  [InspectionTaskEventType.SamplingCheck, 'sampling-check'],
  [InspectionTaskEventType.Completion, 'order-finish'],
  [InspectionTaskEventType.System, 'none'],
]);

export function timelineItemFactory(
  event: EventInfo,
  eventsMap: Map<string, EventInfo>,
): TimelineItemInfo | null {
  if (event.subType === InspectionTaskEventSubType.Rollback) {
    event = {
      ...event,
      type: InspectionTaskEventType.DeliveryCheck,
    };
  }
  const builder = new TimelineItemInfoBuilderImpl(event);
  try {
    const fn = getTimelineItemBuilder(event);
    if (!fn) return null;
    let sectionType: TimelineSectionType = EventType2SectionTypeMap.get(
      event.type,
    )!;
    if (event.subType === InspectionTaskEventSubType.Rollback) {
      sectionType = 'order-rollback';
    } else if (
      event.subType === InspectionTaskEventSubType.Closed ||
      event.subType === InspectionTaskEventSubType.OrderCanceled
    ) {
      sectionType = 'order-close';
    } else if (
      event.subType === InspectionTaskEventSubType.TaskBasicInfoUpdated ||
      event.subType === InspectionTaskEventSubType.OrderInfoUpdated
    ) {
      sectionType = 'order-update';
    }
    builder.sectionType(sectionType);
    fn(builder, builder.data, eventsMap);
  } catch (e) {
    if (!builder.get().label) {
      builder.label((e as Error).message);
    }
  }
  return builder.get();
}
